import { render, staticRenderFns } from "./SignupCard.vue?vue&type=template&id=035f2b3c"
import script from "./SignupCard.vue?vue&type=script&lang=js"
export * from "./SignupCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports